import { Chip, styled } from '@mui/material';
import { lighten } from '@mui/material/styles';
import { MODELS_CALENDAR_EVENT_COLORS } from 'dashboard409a/common/constants/calendar';
import { getCalendarColorPalette } from 'dashboard409a/hooks/useColorPalette';

// Map ModelStatus string values to CalendarColorPalette keys
const MODEL_STATUS_TO_PALETTE_KEY: Record<string, keyof ReturnType<typeof getCalendarColorPalette>> = {
  'Draft': 'DRAFT',
  'Review': 'REVIEW',
  'In-process ScalarUSA': 'IN_PROCESS_SCALAR_USA',
  'Final': 'FINAL',
  'COMPLETE': 'COMPLETE',
  'WAITING': 'WAITING',
};

const getModelStatusColor = (status?: string) => {
  if (!status) {
    return MODELS_CALENDAR_EVENT_COLORS.DEFAULT;
  }

  const palette = getCalendarColorPalette();
  const paletteKey = MODEL_STATUS_TO_PALETTE_KEY[status];
  
  return paletteKey ? palette[paletteKey] : MODELS_CALENDAR_EVENT_COLORS.DEFAULT;
};

interface ModelStatusChipProps {
  status?: string;
}

export const StyledModelStatusChip = styled(Chip)<ModelStatusChipProps>(({ theme, status }) => {
  const baseColor = getModelStatusColor(status);
  const isDark = theme.palette.mode === 'dark';
  // Dark: same pastel color system as light, lightened slightly for less eye strain
  const backgroundColor = isDark ? lighten(baseColor, 0.07) : baseColor;

  return {
    backgroundColor,
    color: theme.palette.getContrastText(backgroundColor),
    // Soft border only in dark: keeps the chip legible on a dark row without blending in
    border: isDark ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
    borderRadius: '10px',
    padding: `0px ${theme.spacing(1.5)}`,
    fontSize: '14px',
  };
});
